import { MessageCircle } from "lucide-react";
import { scrollToId, waLink, DEFAULT_WA_MESSAGE, WHATSAPP_DISPLAY } from "@/lib/site";

const NAV = [
  { id: "home", label: "Home" },
  { id: "about", label: "About Us" },
  { id: "products", label: "Products" },
  { id: "contact", label: "Contact" },
];

const COLLECTIONS = [
  "Wardrobes & Cupboards",
  "Beds & Bedroom Furniture",
  "TV Units",
  "Tables",
  "Dressing Tables",
  "Sofa Beds",
  "Custom Furniture",
];

export const Footer = () => (
  <footer data-testid="main-footer" className="bg-noir text-sand">
    <div className="section-shell pt-16 pb-8">
      <p className="font-serif text-[13vw] leading-none sm:text-7xl lg:text-8xl tracking-tight text-[#2B231E] select-none" aria-hidden="true">
        JK FURNITURE
      </p>
      <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.28em] text-brasslight/60">
        Wooden Furniture Manufacturer — Mumbai · Navi Mumbai · Thane
      </p>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 border-t border-[#2B231E] pt-10">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-brass">Explore</p>
          <ul className="mt-4 space-y-2.5">
            {NAV.map((n) => (
              <li key={n.id}>
                <button
                  data-testid={`footer-link-${n.id}`}
                  onClick={() => scrollToId(n.id)}
                  className="text-sm text-brasslight/75 hover:text-sand transition-colors"
                >
                  {n.label}
                </button>
              </li>
            ))}
            <li>
              <a
                data-testid="footer-whatsapp-link"
                href={waLink(DEFAULT_WA_MESSAGE)}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-[#25D366] hover:text-[#1EBE5D] transition-colors"
              >
                <MessageCircle size={14} /> WhatsApp
              </a>
            </li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-brass">Collections</p>
          <ul className="mt-4 space-y-2.5">
            {COLLECTIONS.map((c) => (
              <li key={c} className="text-sm text-brasslight/75">{c}</li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-brass">Service Areas</p>
          <ul className="mt-4 space-y-2.5 text-sm text-brasslight/75">
            <li>Mumbai</li>
            <li>Navi Mumbai</li>
            <li>Thane</li>
            <li>Maharashtra, India</li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-brass">Reach Us</p>
          <p className="mt-4 font-serif text-xl">{WHATSAPP_DISPLAY}</p>
          <p className="mt-2 text-sm text-brasslight/70">Open all days, 9 AM – 9 PM IST</p>
          <a
            data-testid="footer-whatsapp-cta"
            href={waLink(DEFAULT_WA_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-5 inline-flex items-center gap-2 rounded-full border border-[#25D366]/50 px-5 py-2.5 text-xs font-semibold text-[#25D366] transition-colors hover:bg-[#25D366] hover:text-noir"
          >
            <MessageCircle size={14} /> Start a Chat
          </a>
        </div>
      </div>

      <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-[#2B231E] pt-6">
        <p className="text-xs text-brasslight/60">© JK Furniture. All Rights Reserved.</p>
        <a href="/admin" data-testid="footer-admin-link" className="text-xs text-brasslight/40 hover:text-brasslight/80 transition-colors">
          Owner Login
        </a>
      </div>
    </div>
  </footer>
);
